<template>
  <div class="text-xs-center">
    <v-dialog v-model="dialog" width="90%">
      <v-card>
        <v-toolbar color="primary" dark>
          <v-toolbar-title>{{titleAction}}</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn @click="cancel()" dark icon>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <v-card-text>
          <v-container fluid grid-list-xl>
            <v-layout wrap>
              <v-flex d-flex lg4 md4 sm12 xs12>
                <v-text-field
                  :disabled="!Edit"
                  :rules="[v => rules.vacio(v, 'name')]"
                  :label="$t('name')"
                  v-model="teamName"
                ></v-text-field>
              </v-flex>
              <v-flex d-flex lg4 md4 sm12 xs12>
                <v-autocomplete
                  :disabled="!Edit"
                  :items="treeForSelect(1, tree)"
                  :rules="[v => rules.vacio(v, 'category')]"
                  :label="$tc('category')"
                  persistent-hint
                  prepend-icon="mdi-city"
                  v-model="category"
                ></v-autocomplete>
              </v-flex>
              <v-flex d-flex lg4 md4 sm12 v-if="!entityOmit" xs12>
                <v-autocomplete
                  :disabled="externalAction !== 'create'"
                  :items="listEntities"
                  :rules="[v => rules.vacio(v, 'entity')]"
                  :label="$tc('entity')"
                  persistent-hint
                  prepend-icon="mdi-city"
                  v-model="entity"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12>
                <!-- <v-autocomplete
                  v-model="participants"
                  :items="participantUsers"
                  :disabled="!Edit"
                  item-text="name"
                  chips
                  multiple
                  @change="searchUser = ''"
                  :search-input.sync="searchUser"
                  :label="$t('select', {field :$t('participants') })"
                >
                  <template v-slot:selection="data">
                    <v-chip
                      color="white"
                      :selected="data.selected"
                      class="chip--select-multi"
                      close
                      @input="removeParticipant(data.item)"
                    >
                      <v-avatar>
                        <img :src="data.item.photo" />
                      </v-avatar>
                      {{ data.item.text }}
                    </v-chip>
                  </template>
                  <template v-slot:item="data">
                    <v-list-tile-avatar>
                      <img :src="data.item.photo" />
                    </v-list-tile-avatar>
                    <v-list-tile-content>
                      <v-list-tile-title v-html="data.item.text"></v-list-tile-title>
                    </v-list-tile-content>
                  </template>
                </v-autocomplete>-->
                <user-field
                  v-model="participants"
                  populate-entity
                  :type-role="'participant'"
                  multiple
                  :label="$t('select', {field :$t('participants') })"
                ></user-field>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>
          <template v-if="externalAction != 'view'">
            <v-btn
              @click="reset()"
              color="warning"
              small
              v-if="externalAction !== 'remove'"
            >{{$t('reset')}}</v-btn>
            <v-btn
              @click="create()"
              color="success"
              small
              :loading="loading"
              v-if="externalAction === 'create' && can('create', 'team')"
            >{{$t('save')}}</v-btn>
            <v-btn
              @click="update()"
              color="secondary"
              small
              :loading="loading"
              v-if="externalAction === 'update' && can('edit', 'team', externalTeam)"
            >{{$t('update')}}</v-btn>
            <v-btn
              @click="remove()"
              color="error"
              small
              :loading="loading"
              v-if="externalAction === 'remove' && can('delete', 'team', externalTeam)"
            >{{$t('delete')}}</v-btn>
          </template>

          <v-btn @click="cancel()" color="primary" small>{{$t('cancel')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'
import queueToast from '../../../helpers/queueToast'
import rules from '../../../helpers/rules'
import { treeForSelect } from '../../../helpers/tree'
import UserField from '@/components/widgets/Input/UserField'

export default {
  name: 'formManager',
  components: { UserField },
  mixins: [rules],
  props: {
    modal: {
      type: Boolean,
      default: false,
      required: true
    },
    Edit: {
      type: Boolean,
      default: false,
      required: false
    },
    externalAction: {
      type: String,
      default: 'create',
      required: false
    },
    externalTeam: {
      type: Object,
      default: () => {
        return {}
      },
      required: false
    },
    entityOmit: {
      type: Boolean,
      required: false,
      default: false
    },
    entityId: {
      type: String,
      required: false,
      default: ''
    }
  },
  data() {
    return {
      searchUser: '',
      teamName: '',
      category: '',
      entity: '',
      participants: [],

      loading: false
    }
  },
  watch: {
    entityId: function(val) {
      this.actions()
    },
    externalTeam: function(val) {
      this.actions()
    },
    externalAction: function(val) {
      this.actions()
    }
  },
  mounted() {
    this.category = this.externalTeam.categoryId
    this.teamName = this.externalTeam.name
    this.actions()
  },
  computed: {
    ...mapState({
      teamId: state => state.teams.idSelected,
      listEntities: state => state.entities.listSelectEntities,
      listUsers: state => state.users.listSelectUsers
    }),
    ...mapGetters({
      listCategories: 'categories/selectList',
      tree: 'categories/categoriesTree'
    }),
    dialog: {
      get() {
        return this.modal
      },
      set(value) {
        this.$emit('close')
      }
    },
    participantUsers() {
      return this.listUsers.filter(user => user.roles.includes('participant'))
    },
    titleAction() {
      switch (this.externalAction) {
        case 'create':
          return this.$t('newModel', { field: this.$tc('team') })
        case 'remove':
          return this.$t('deleteModel', { field: this.$tc('team') })
        case 'update':
          return this.$t('updateModel', { field: this.$tc('team') })
      }
    }
  },
  methods: {
    ...mapActions({
      setCreate: 'teams/setCreateNew',
      setUpdate: 'teams/setUpdateTeam',
      setRemove: 'teams/setDeleteTeam'
    }),
    actions() {
      switch (this.externalAction) {
        case 'create':
          this.actionCreate()
          break
        case 'remove':
          this.actionRemove()
          break
        case 'view':
        case 'update':
          this.actionUpdate()
          break
      }
    },
    actionUpdate() {
      this.nextTick(_ => {
        this.category = this.externalTeam.categoryId
        this.teamName = this.externalTeam.name
        this.entity = this.externalTeam.entityId
        this.participants = this.externalTeam.participants || []
      })
    },
    actionRemove() {
      this.nextTick(_ => {
        this.category = this.externalTeam.categoryId
        this.teamName = this.externalTeam.name
        this.entity = this.externalTeam.entityId
        this.participants = this.externalTeam.participants || []
      })
    },
    actionCreate() {
      this.nextTick(_ => {
        this.entity = this.entityOmit ? this.entityId : ''
        this.category = ''
        this.teamName = ''
        this.participants = []
      })
    },
    verifyBeforeSend() {
      let result = true
      let message = []
      if (this.teamName === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('name') }))
      }
      if (this.category === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('category') }))
      }
      if (this.entity === '') {
        result = false
        message.push(this.$t('error.required', { field: this.$tc('entity') }))
      }
      return {
        result,
        message
      }
    },
    createTeam() {
      return {
        idEntity: this.entity,
        team: {
          name: this.teamName,
          categoryId: this.category,
          participants: this.participants
        }
      }
    },
    cancel() {
      this.reset()
      this.$emit('close')
    },
    create() {
      const error = this.verifyBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }
      let team = this.createTeam()
      this.loading = true
      this.setCreate(team)
        .then(result => this.cancel())
        .finally(_ => (this.loading = false))
    },
    update() {
      const error = this.verifyBeforeSend()
      if (!error.result) {
        queueToast(error.message)
        return
      }

      let team = this.createTeam()
      team.team._id = this.externalTeam._id
      this.loading = true
      this.setUpdate(team)
        .then(result => this.cancel())
        .finally(_ => (this.loading = false))
    },
    remove() {
      this.loading = true
      this.setRemove({
        idEntity: this.externalTeam.entityId,
        idTeam: this.externalTeam._id
      })
        .then(result => this.cancel())
        .finally(_ => (this.loading = false))
    },
    reset() {
      this.category = ''
      this.teamName = ''
      this.entity = ''
      this.participants = []
    },
    treeForSelect(nivel, tree) {
      return treeForSelect(nivel, tree)
    },
    removeParticipant(item) {
      const index = this.participants.indexOf(item.value)
      if (index >= 0) this.participants.splice(index, 1)
    }
  }
}
</script>
